import React from "react";

const EachCourse = ({ course, submenu }) => {
  const [showCourses, setShowCourses] = React.useState(false);
  

  return (
    <>
      <div className="sidebar-courses" style={{fontSize:'.8rem'}}> 
        <h3>{course}</h3>
        <button className="plus-minus-btn" onClick={() => setShowCourses(!showCourses)}>{showCourses ? <i className="ri-subtract-line"></i> : <i className="ri-add-line"></i>}</button>
      </div>

      {showCourses && [
        submenu.map((item, index) => {
          const { category ,id} = item;
          return <>
          <div className="items" key={index}>
            <div className="items-wrapper" style={{display:'grid'}}>
                <a href="/" key={id}>{category}</a>
            </div>

          </div>
          </>;
        }),
      ]}
    </>
  );
};

export default EachCourse;
